import dayjs from "dayjs";
import "dayjs/locale/sv";

export const getDateFromDateString = (date: string): Date => {
  dayjs.locale("sv");
  return dayjs(date).toDate();
};
